import { combineReducers } from "redux";
import { lookupsReducers } from "./lookups";
import { userReducers } from "./user";
import { projectsReducers } from "./projects";
import { earningsReducers } from "./earnings";
import { ratesReducers } from "./rates";
import { invoicesReducers } from "./invoices";

export const appReducer = combineReducers({
  ...lookupsReducers,
  ...userReducers,
  ...projectsReducers,
  ...earningsReducers,
  ...ratesReducers,
  ...invoicesReducers,
});
